<template>
  <v-container fluid>
    <page-header
      title="사이트 관리"
      @searchBtn="search_site"
      @setBill="input_bill"
      @inverterSiteAdd="goUrl('SiteRegister')"
      @excelDown="excelDown"
      :custom-button-list="customButtonList"
      :useList="buttonUseList"
    />
    <v-card>
      <v-card-text>
        <v-layout class="pl-6 pr-6">
          <v-row>
            <v-col cols="12" sm="6" class="py-0 mb-2">
              <v-select
                class="fontSize9 mr-3"
                style="width: 100%;"
                :items="selectItems"
                label="선택"
                v-model="search_type"
                item-text="name"
                item-value="value"
                dense
                outlined
                hide-details="true"
              ></v-select>
            </v-col>
            <v-col
              cols="12"
              sm="3"
              class="py-0 mb-2"
              hide-details
              flat
              v-if="search_type === 'date'"
            >
              <v-menu
                v-model="startDate"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="date1"
                    label="시작일"
                    outlined
                    hide-details
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    dense
                  ></v-text-field>
                </template>
                <v-date-picker v-model="date1" @input="startDate = false" no-title></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="3" class="py-0" hide-details flat v-if="search_type === 'date'">
              <v-menu
                v-model="endDate"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="date2"
                    label="종료일"
                    outlined
                    hide-details
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    dense
                  ></v-text-field>
                </template>
                <v-date-picker v-model="date2" @input="endDate = false" no-title></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="6" class="py-0" hide-details="true" flat="true" v-else>
              <v-text-field
                dense
                outlined
                hide-details
                v-on:keyup.enter="search_site"
                v-model="search_word"
              />
            </v-col>
          </v-row>
        </v-layout>
      </v-card-text>
    </v-card>
    <div class="result_table">
      <div id="realgrid" ref="realgrid" class="mt-1 mb-5 w-full"></div>
    </div>
    <v-dialog v-model="isLayer" persistent max-width="500">
      <v-card>
        <v-card-title class="text-h5">사이트청구 입력</v-card-title>
        <v-card-text class="pb-0">
          <!-- content -->
          <v-row class="mb-3" no-gutters>
            <v-col cols="3" class="sub_title">사이트 명</v-col>
            <v-col cols="9" class="sub_title">{{ site_nm }}</v-col>
          </v-row>
          <v-row>
            <v-spacer></v-spacer>
            <v-btn @click="addItem" class="mr-2">+ 아이템 추가</v-btn>
            <v-btn @click="delItem">- 아이템 삭제</v-btn>
          </v-row>
        </v-card-text>
        <v-card
          class="ma-3 pa-2 pt-0 mb-2"
          v-for="(item, idx) in billItems"
          :key="idx"
          :id="'items_'+idx"
          ref="items_box"
          name="items_box"
        >
          <v-row no-gutters>
            <v-col cols="12">
              <v-checkbox
                class="mt-0"
                v-model="item.checkyn"
                :label="'아이템 ' + (idx + 1)"
                hide-details
                dense
              ></v-checkbox>
            </v-col>
            <v-col class="mr-2">
              <v-select
                :id="'itm_'+idx"
                :items="itemCodeList"
                item-text="txt"
                item-value="val"
                v-model="item.item"
                v-on:change="autoTemp(item)"
                dense
                small
                outlined
                hide-details
              ></v-select>
            </v-col>
            <v-col class="mr-2">
              <v-select
                :items="dialogSet"
                item-text="txt"
                item-value="val"
                v-model="item.qty"
                v-on:change="autoTemp(item)"
                dense
                small
                outlined
                hide-details
              ></v-select>
            </v-col>
            <v-col>
              <v-text-field
                type="number"
                pattern="[0-9]*"
                v-model="item.price"
                dense
                small
                outlined
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card>
        <v-card-actions class="d-flex justify-center">
          <v-btn color="green darken-1" text @click="closeLayer">취소</v-btn>
          <v-btn color="green darken-1" text @click="saveSiteBillMngtMaster">저장</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import {
  getBillMngCodeList,
  getSiteBillMngtList,
  getSiteBillMngtDetail,
  setSiteBillMngtMaster,
  delSiteBillMngt,
  getSiteList
} from '@/api/master/master'
import localStore from '@/utils/localStore'
import { getUserId } from '@/api/greenCommon/user'
import PageHeader from '@/layout/components/PageHeader'
import RealGridJS from 'realgrid/dist/main'
import { isMobile } from '@/utils/check.js'
import { debuglog } from 'util'
import Message from '@/utils/message'

let dataProvider
let gridView

export default {
  name: 'SiteManage',
  data() {
    return {
      startDate: false,
      endDate: false,
      dialogSet: [
        { txt: '1EA', val: '1' },
        { txt: '2EA', val: '2' },
        { txt: '3EA', val: '3' },
        { txt: '4EA', val: '4' }
      ],
      buttonUseList: [],
      customButtonList: [
        { id: 'searchBtn', text: '조회', icon: 'mdi-magnify' },
        { id: 'inverterSiteAdd', text: '인버터 사이트 등록', icon: '' },
        { id: 'excelDown', text: '엑셀', icon: '' },
        { id: 'setBill', text: '프리미엄 등록', icon: '' }
      ],
      selectItems: [
        { name: '사이트명', value: 'site_nm' },
        { name: '사이트 ID', value: 'site_id' },
        { name: '사용자명', value: 'site_owner_nm' },
        { name: '전화번호', value: 'user_phone' },
        { name: '사이트 등록자', value: 'regist' },
        { name: '설치일자 검색', value: 'date' },
        { name: '시리얼넘버', value: 'serial' },
        { name: '접속 URL', value: 'url' },
        { name: '주소', value: 'location' },
        { name: '비고', value: 'remark' }
      ],
      date_show: false,
      date1: this.$time(Date.now()).format('YYYY-MM-DD'),
      date2: this.$time(Date.now()).format('YYYY-MM-DD'),
      nowDate: this.$time(Date.now()).format('YYYY-MM-DD'),
      siteBillMngtList: [],
      siteList: [],
      search_type: 'site_nm',
      search_word: '',
      codenm: '',
      site_id: '',
      site_nm: '',
      user_id: '',
      user_nm: '',
      grid: {
        gridFields: [],
        gridColumns: [],
        gridOption: {},
        gridStyle: {}
      },
      isLayer: false,
      // 2020-02-10 김진희 - 관리자 전용 메뉴 변수 추가
      isMaster: false,
      billItems: [1],
      itemCodeList: [
        { txt: '100KW 미만', val: 'BASIC' },
        { txt: '100KW 이상', val: 'PLTE' },
        { txt: '100KW 미만 + CCTV', val: 'CCTV1' },
        { txt: '100KW 이상 + CCTV', val: 'CCTV2' },
        { txt: '100KW 미만(공유)', val: 'BASIC_NEW' },
        { txt: '100KW 이상(공유)', val: 'PLTE_NEW' },
        { txt: '유선 공유', val: 'LINE_SHARE' },
        { txt: '유선', val: 'LINE' }
      ],
      commonCode: [],
      beforeSelItem: ''
    }
  },
  components: {
    PageHeader
  },
  mounted() {
    if (isMobile()) {
      this.customButtonList.splice(2, 2)
    }
    this.init_data()
    // 초기 데이터 로딩 안함
    this.init_grid()
    this.getUserId3()
  },
  watch: {
    isMobile() {
      console.log(this.isMobile())
    },
    search_type: function(newVal) {
      if (newVal === 'date') {
        this.date_show = true
      } else {
        this.date_show = false
      }
    }
  },
  methods: {
    autoTemp(i) {
      // i.item , i.qty
      if (i.item === 'BASIC') {
        i.price = (15000 * Number(i.qty)).toString()
      } else if (i.item === 'PLTE') {
        i.price = (25000 * Number(i.qty)).toString()
      } else if (i.item === 'CCTV1') {
        i.price = (25000 * Number(i.qty)).toString()
      } else if (i.item === 'CCTV2') {
        i.price = (30000 * Number(i.qty)).toString()
      } else if (i.item === 'LINE') {
        i.price = (25000 * Number(i.qty)).toString()
      } else if (i.item === 'BASIC_NEW') {
        i.price = (15000 * Number(i.qty)).toString()
      } else if (i.item === 'PLTE_NEW') {
        i.price = (18000 * Number(i.qty)).toString()
      } else if (i.item === 'LINE_SHARE') {
        i.price = (17000 * Number(i.qty)).toString()
      }
    },
    goUrl(r) {
      console.log(r)
      this.$router.push({ name: r })
    },
    isDateSearch() {
      console.log('isDateSearch 진입')
      if (this.search_type === 'date') {
        this.date_show = true
      }
    },
    getUserId3() {
      // let params = {
      //   kor_nm: '메가솔라'
      // }
      // getUserId(params).then(response => {
      //   this.user_id = response
      // })
    },
    getUserId2(params) {
      let para = {
        kor_nm: params
      }
      getUserId(para).then(response => {
        this.user_id = response.user_id
        console.log('@@@SITE_ID@@@')
        console.log(response)
        console.log(this.user_id)
      })
    },
    excelDown() {
      gridView.exportGrid({
        type: 'excel',
        target: 'local',
        fileName: 'siteManage_' + this.nowDate + '.xlsx',
        // progressMessage: "엑셀 Export중입니다.",
        indicator: 'hidden',
        footer: 'hidden'
      })
    },
    mqttTestClick() {
      mqttTest().then(response => {
        console.log(response)
      })
    },
    siteBillMngtMasterDetail() {
      if (!this.site_id) {
        Message.warn('사이트를 선택해주세요!')
        return false
      }
      let params = {
        site_id: this.site_id
      }
      getSiteBillMngtDetail(params).then(response => {
        this.billItems = response
        this.isLayer = true
      })
    },
    input_bill() {
      this.siteBillMngtMasterDetail()
    },
    saveSiteBillMngtMaster() {
      this.billItems.forEach(res => {
        if (!res.item || !res.price || !res.qty) {
          alert('아이템 정보를 입력해주세요')
          return false
        }
      })

      let params = {
        user_id: this.user_id,
        site_id: this.site_id,
        login_id: localStore.get('userId'),
        item_list: this.billItems
      }

      delSiteBillMngt(params).then(response => {
        setSiteBillMngtMaster(params).then(response => {
          alert('저장되었습니다.')
          getSiteBillMngtList({}).then(response => {
            this.siteBillMngtList = response
            // dataProvider.fillJsonData(this.siteBillMngtList)
            this.closeLayer()
          })
        })
      })
    },
    closeLayer() {
      this.isLayer = false
      this.items = [1]
    },
    selItem(e) {
      this.beforeSelItem = e.target.value
    },
    addItem() {
      this.billItems.push({
        checkyn: false,
        qty: '1',
        price: '15000',
        price_text: '',
        item: 'BASIC'
      })
    },
    delItem() {
      console.log(this.billItems.length)
      if (this.billItems.length === 1) {
        this.billItems = []
      } else {
        for (let x = this.billItems.length - 1; x >= 0; x--) {
          if (this.billItems[x].checkyn) {
            this.billItems.splice(x, 1)
          }
        }
      }
    },
    itemChange(gubun, e) {
      let item =
        gubun === 'item'
          ? e.target.value
          : $(e.target)
            .parent()
            .find('select')
            .eq(0)
            .val()
      let qty =
        gubun === 'item'
          ? $(e.target)
            .parent()
            .find('select')
            .eq(1)
            .val()
          : e.target.value
      let cnt = this.beforeSelItem ? 0 : -1

      // 중복 방지
      $.each($("[name='items_box']"), function(idx, items) {
        if (
          item ===
          $(items)
            .find('select')
            .eq(0)
            .val()
        ) {
          cnt++
        }
      })
      if (cnt > 0 && gubun === 'item') {
        alert('중복되는 아이템입니다.')
        $(e.target).val(this.beforeSelItem)
        return
      }

      // 금액 추가
      let attribute1 = 0
      $.each(this.commonCode, function(idx, code) {
        $.each(code, function(key, value) {
          if (value === item) attribute1 = code['attribute1'] * qty
          $(e.target)
            .parent()
            .find('input[type=text]')
            .val(attribute1)
        })
      })

      if (this.beforeSelItem) {
        this.items[Number(e.target.id.substr(4))].qty = qty
      } else {
        this.items[Number(e.target.id.substr(4))] = {
          item: item,
          qty: qty,
          price: attribute1
        }
      }
    },
    init_data() {
      let params = {
        search_type: this.search_type,
        search_word: this.search_word
      }

      getBillMngCodeList(params).then(response => {
        this.commonCode = response
      })

      // 2020-02-10 김진희 - 관리자일 경우 관리자 전용 버튼 활성화
      const grpAuth = this.$store.state.user.grp_auth || ''
      if (grpAuth === 'usergroup001' || grpAuth === 'usergroup002') {
        this.isMaster = true
      }

      // 2020-02-10 김진희 - 중복된 코드 함수 호출로 변경
      this.search_site()
    },
    search_site() {
      let params = {
        // 2020-02-10 김진희 - user_id 전달하게함
        user_id: localStore.get('userId'),
        // user_id: 'TestAdmin',
        search_type: this.search_type,
        search_word: this.search_word,
        date1: this.date1,
        date2: this.date2
      }
      getSiteList(params).then(response => {
        this.siteList = response
        console.log(response)
        dataProvider.fillJsonData(this.siteList)
      })
    },
    siteMasterDetail() {
      if (this.codenm.indexOf('E') > -1) {
        this.$router.push({
          name: 'SiteEssReg',
          query: {
            site_id: this.codenm,
            search_type: this.search_type,
            search_word: this.search_word
          }
        })
      } else {
        this.$router.push({
          name: 'SiteRegister',
          query: {
            site_id: this.codenm,
            search_type: this.search_type,
            search_word: this.search_word
          }
        })
      }

      //      this.$router.push('/master/SiteRegister' + this.codenm)
    },
    init_grid() {
      dataProvider = new RealGridJS.LocalDataProvider()
      gridView = new RealGridJS.GridView('realgrid')
      gridView.setDataSource(dataProvider)
      gridView.setRowIndicator({
        visible: false
      })
      setTimeout(() => {
        gridView.setOptions(this.grid.gridOption)
        // gridView.setStyles(this.grid.gridStyle)
      }, 2000)
      let fields, columns
      if (isMobile()) {
        fields = [
          { fieldName: 'user_nm', dataType: 'string' },
          { fieldName: 'description', dataType: 'string' },
          { fieldName: 'codenm', dataType: 'string' },
          { fieldName: 'location', dataType: 'string' }
        ]
        columns = [
          {
            name: 'description',
            fieldName: 'description',
            header: { text: '사이트 명' },
            styles: {
              textAlignment: 'center'
            }
          },
          {
            name: 'user_nm',
            fieldName: 'user_nm',
            header: { text: '사용자' },
            hoveredBackground: '#ccc',
            styles: {
              textAlignment: 'center'
            }
          },
          {
            name: 'location',
            fieldName: 'location',
            header: { text: '지역' },
            styles: {
              textAlignment: 'center'
            }
          }
        ]
      } else {
        fields = [
          { fieldName: 'agency', dataType: 'string' },
          { fieldName: 'user_nm', dataType: 'string' },
          { fieldName: 'description', dataType: 'string' },
          { fieldName: 'codenm', dataType: 'string' },
          { fieldName: 'planttype_name', dataType: 'string' },
          { fieldName: 'location', dataType: 'string' },
          { fieldName: 'model', dataType: 'string' },
          { fieldName: 'pcs_capa', dataType: 'string' },
          { fieldName: 'callurl', dataType: 'string' },
          { fieldName: 'module_maker', dataType: 'string' },
          { fieldName: 'module_type', dataType: 'string' },
          { fieldName: 'roof_floor', dataType: 'string' },
          { fieldName: 'angle', dataType: 'string' },
          { fieldName: 'crt_date', dataType: 'string' },
          { fieldName: 'combined_remark', dataType: 'string' },
          { fieldName: 'useyn', dataType: 'string' }
        ]
        columns = [
          {
            name: 'agency',
            fieldName: 'agency',
            header: { text: '대리점' },
            hoveredBackground: '#ccc',
            width: 60,
            styles: {
              textAlignment: 'center'
            }
          },
          {
            name: 'user_nm',
            fieldName: 'user_nm',
            header: { text: '사용자' },
            hoveredBackground: '#ccc',
            styles: {
              textAlignment: 'center'
            }
          },
          {
            name: 'description',
            fieldName: 'description',
            header: { text: '사이트 명' },
            styles: {
              textAlignment: 'center'
            }
          },
          {
            name: 'codenm',
            fieldName: 'codenm',
            header: { text: '사이트 ID' },
            width: 30,
            styles: {
              textAlignment: 'center'
            }
          },
          {
            name: 'planttype_name',
            fieldName: 'planttype_name',
            header: { text: '구분' },
            width: 30,
            styles: {
              textAlignment: 'center'
            }
          },
          {
            name: 'location',
            fieldName: 'location',
            header: { text: '지역' },
            styles: {
              textAlignment: 'center'
            }
          },
          {
            name: 'crt_date',
            fieldName: 'crt_date',
            header: { text: '설치 일자' },
            width: 50,
            styles: {
              textAlignment: 'center'
            }
          },
          {
            name: 'model',
            fieldName: 'model',
            header: { text: 'Model' },
            styles: {
              textAlignment: 'center'
            }
          },
          {
            name: 'pcs_capa',
            fieldName: 'pcs_capa',
            header: { text: '용량' },
            width: 30,
            styles: {
              textAlignment: 'center'
            }
          },
          {
            name: 'callurl',
            fieldName: 'callurl',
            header: { text: 'URL' },
            styles: {
              textAlignment: 'center'
            }
          },
          {
            name: 'module_maker',
            fieldName: 'module_maker',
            header: { text: '모듈 제조사' },
            styles: {
              textAlignment: 'center'
            }
          },
          {
            name: 'module_type',
            fieldName: 'module_type',
            header: { text: '모듈 타입' },
            styles: {
              textAlignment: 'center'
            }
          },
          {
            name: 'roof_floor',
            fieldName: 'roof_floor',
            header: { text: '대지/지붕' },
            width: 40,
            styles: {
              textAlignment: 'center'
            }
          },
          {
            name: 'angle',
            fieldName: 'angle',
            header: { text: '설치 각도' },
            width: 40,
            styles: {
              textAlignment: 'center'
            }
          },
          {
            name: 'combined_remark',
            fieldName: 'combined_remark',
            header: { text: '비고 1/2/3/4' },
            styles: {
              textAlignment: 'center'
            }
          },
          {
            name: 'useyn',
            fieldName: 'useyn',
            header: { text: '사용여부' },
            styles: {
              textAlignment: 'center'
            }
          }
        ]
      }

      dataProvider.setFields(fields)
      gridView.setColumns(columns)
      // gridView.setSelectOptions({
      //   style: 'singleRow'
      // })
      gridView.onCellClicked = function(grid, index) {
        console.log(grid)
        console.log(index)
        this.site_id = dataProvider.getValue(index.dataRow, 'codenm')
        this.site_nm = dataProvider.getValue(index.dataRow, 'description')
        this.user_nm = dataProvider.getValue(index.dataRow, 'user_nm')
        // this.user_id = dataProvider.getValue(index.dataRow, 'user_nm')
        this.getUserId2(dataProvider.getValue(index.dataRow, 'codenm'))
      }.bind(this)
      gridView.onCellDblClicked = function(grid, index) {
        this.codenm = dataProvider.getValue(index.dataRow, 'codenm')
        this.siteMasterDetail()
      }.bind(this)
    }
  },
  created() {
    if (this.$router.history.current.query.search_type !== undefined) {
      this.search_type = this.$router.history.current.query.search_type
    }
    if (this.$router.history.current.query.search_word !== undefined) {
      this.search_word = this.$router.history.current.query.search_word
    }
    this.grid.gridOption = {
      panel: {
        visible: false
      },
      stateBar: {
        visible: false
      },
      checkBar: {
        visible: false
      },
      indicator: {
        visible: false
      },
      footer: {
        visible: false
      },
      edit: {
        appendable: false,
        insertable: false,
        deletable: false,
        readOnly: false,
        editable: false,
        updatable: false
      },
      header: {
        styles: {
          fontSize: '14',
          fontFamily: 'NanumGothic',
          foreground: '#fff',
          fontBold: 'false',
          background: '#5c97cd',
          selectedBackground: '#9bb2c7',
          borderLeft: '#fff',
          borderRight: '#fff'
        },
        selection: {
          background: '#efefef',
          border: '#ccc,1'
        }
      },
      display: {
        fitStyle: 'evenFill',
        heightMeasurer: 'fixed',
        rowHeight: 30,
        focusVisible: false,
        showEmptyMessage: true,
        emptyMessage: '조회된 정보가 없습니다.'
      },
      sorting: {
        handleColor: '#fff',
        hoveredHandleColor: '#fff'
      },
      select: {
        style: 'none'
      }
    }

    this.grid.gridStyle = {
      body: {
        fontSize: '14',
        fontFamily: 'NanumGothic',
        foreground: '#666',
        fontBold: 'false',
        borderLeft: '#fff,0',
        borderRight: '#ccc,1',
        borderBottom: '#ccc,1',
        empty: {
          textAlignment: 'center',
          lineAlignment: 'center',
          fontSize: 14,
          fontBold: false
        },
        dynamicStyles: [
          {
            criteria: '(row mod 2) = 0',
            styles: {
              background: '#F4F4FA'
            }
          }
        ]
      }
    }
  }
}
</script>

<style lang='less' scoped>
// @import '../../../assets/master.less';
// @import '../../../assets/manage.less';

.layer_frame {
  overflow: auto;
}

.btn {
  display: inline-block;
  height: 30px;
  padding: 0 10px;
  border: 1px solid #b1b1b1;
  background: #ededed;
  color: #676767;
  cursor: pointer;
  font-weight: bold;
  line-height: 30px;
}

.btn:first-child {
  margin-right: 5px;
}

.com_select {
  display: flex;
}
.com_select > select {
  margin-right: 5px;
}

.price_text {
  text-align: right;
}
.main-box,
.mx-auto,
.p-4,
.xl:p-0 {
  margin: 0;
  padding: 0;
}
#realgrid {
  height: 500px;
  width: 100%;
  margin-top: 0;
  margin-bottom: 20px;
  margin-left: auto;
  margin-right: auto;
}

.layer_frame {
  overflow: auto;
}

.btn {
  display: inline-block;
  height: 30px;
  padding: 0 10px;
  border: 1px solid #b1b1b1;
  background: #ededed;
  color: #676767;
  cursor: pointer;
  font-weight: bold;
  line-height: 30px;
}

.btn:first-child {
  margin-right: 5px;
}

.com_select {
  display: flex;
}
.com_select > select {
  margin-right: 5px;
}

.price_text {
  text-align: right;
}

.excel_down {
  width: 80px;
  height: 27px;
  border: 1px solid #24943e;
  color: #24943e;
  text-align: center;
  line-height: 28px;
  font-weight: bold;
  cursor: pointer;
  box-sizing: border-box;
  background-color: #fff;
  margin-right: 10px;
}

// #dates {
//   float: right;
//   width: 250px;
// }

#date1 {
  width: 105px;
  display: inline-block;
}

#date2 {
  width: 105px;
  display: inline-block;
}
.linkBtn {
  float: left;
  position: relative;
  top: 15px;
  margin-right: 10px;
  padding-left: 16px;
  background: url('~@/assets/location_arrow.png') no-repeat 0 5px;
  font-size: 12px;
  line-height: 18px;
  color: white;
  font-weight: 700;
}
a.home.linkBtn {
  width: 16px;
  height: 13px;
  margin-top: 2px;
  background: url('~@/assets/home.png') no-repeat 0 0;
  text-indent: -9999px;
}
/deep/.fontSize9 {
  font-size: 12px;
}
.sub_title {
  font-size: 1rem;
}
</style>
